<script>
import { mapActions } from 'vuex'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import seasons from '@utils/seasons'
import {
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DatasetComponent,
} from 'echarts/components'
import MChart, { THEME_KEY } from 'vue-echarts'

use([
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DatasetComponent,
  CanvasRenderer,
  BarChart,
])

export default {
  components: {
    MChart,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
      required: true,
    },
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: '30px',
          bottom: '2w0px',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0,
            fontSize: '10px',
          },
        },
        yAxis: {
          type: 'value',
          name: this.$t('goals_season.goals_axis_title'),
        },
        series: [
          {
            data: [],
            type: 'bar',
          },
        ],
      },
      seasons: [
        {
          season: '2021/22',
          label: '21/22',
        },
        {
          season: '2020/21',
          label: '20/21',
        },
        // {
        //   season: '2019/20',
        //   label: '19/20',
        // },
      ],
    }
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  async created() {
    this.seasons = seasons(3).map((season) => ({
      season: season,
      label: season.substring(2, 7),
    }))

    this.loadData()

    this.loaded = true
    this.$emit('loaded', true)
  },
  methods: {
    ...mapActions('players', ['getPlayerStatData']),
    loadData() {
      this.option.series.data = []
      this.option.xAxis.data = []

      const playerStatsPromises = this.seasons.map((season, index) =>
        this.getPlayerStatData({
          id: this.playerId,
          season: season.season,
        }).catch((error) =>
          console.error(
            "Couldn't get PlayerStatData for Season: " +
              this.seasons[index].label,
            error
          )
        )
      )

      Promise.all(playerStatsPromises).then((playerStats) => {
        playerStats.forEach((playerStat, index) => {
          if (playerStat !== undefined) {
            this.option.series[0].data.push(playerStat.goals)
            this.option.xAxis.data.push(this.seasons[index].label)
          }
        })
      })
    },
    onResize() {
      if (typeof this.$refs.chart !== 'undefined') this.$refs.chart.resize()
    },
  },
}
</script>

<template>
  <v-responsive
    v-if="playerId !== null && playerId"
    v-resize="onResize"
    :class="$style.responsive"
    aspect-ratio="4/3"
    :content-class="$style.contentClass"
  >
    <MChart v-if="loaded" ref="chart" :class="$style.chart" :option="option" />
  </v-responsive>
</template>

<style lang="scss" module>
@import '@design';

.chart {
  width: 250px;
  height: 200px;
  margin: 0 auto;

  @media screen and (min-width: $screen-lg) {
    width: 200px;
    height: 140px;
  }
}

.responsive {
  @media screen and (max-width: $screen-lg) {
    min-height: 12rem;
  }
}

.contentClass {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
